export const INCOME_FORM_FINANCIAL_ASSETS_KEYS = [
    { "key": "schemeName", "title": "Scheme Name", "type": "text", "order": 1 },
    { "key": "nameOfParticular", "title": "Name of Bank/FI / Particulars", "type": "text", "order": 2 },
    { "key": "bondName", "title": "Name of Bond / Bank/FI", "type": "text", "order": 3 },
    { "key": "registrationNo", "title": "Registration No. / Account No.", "type": "text", "order": 4 },
    { "key": "accountType", "title": "Account Type", "type": "text", "order": 5 },
    { "key": "branchName", "title": "Branch Name", "type": "text", "order": 6 },
    { "key": "dateOfIssue", "title": "Issue Date", "type": "text", "order": 7 },
    { "key": "dateOfMaturity", "title": "Date of Maturity", "type": "text", "order": 8 },
    { "key": "issueOffice", "title": "Issuing Office", "type": "text", "order": 9 },
    { "key": "paymentAuthority", "title": "Payment Authority", "type": "text", "order": 10 },
    { "key": "value", "title": "Value", "type": "amount", "order": 11 },
    { "key": "grossInterest", "title": "Gross Interest / Gross Amount", "type": "amount", "order": 12 },
    { "key": "relatedExpenses", "title": "Related Expenses", "type": "amount", "order": 13 },
    { "key": "deductedTax", "title": "TDS / Tax Deducted", "type": "amount", "order": 14 },
    { "key": "yearEndBalance", "title": "Year End Balance", "type": "amount", "order": 15 },
    { "key": "taxableIncome", "title": "Taxable Income", "type": "amount", "order": 16 },
    { "key": "sroNo", "title": "SRO No./Reference", "type": "text", "order": 17 },
    { "key": "year", "title": "Year", "type": "text", "order": 18 },
    { "key": "particularSro", "title": "Particular", "type": "text", "order": 19 },
    { "key": "totalExpense", "title": "Total Expense", "type": "amount", "order": 20, "scope": "parent" },
    { "key": "applicableTaxSRO", "title": "Tax Applicable", "type": "amount", "order": 21, "scope": "parent" }
]
